import axios from "axios";
import { resolve } from "./resolve.js";
import { API_AUTH_URL } from "../constants/consts";
import { getSession } from "./sessionManagement";

export async function changeUserLanguageOnServer(language: string) {
  const sessionId = getSession();
  if (!sessionId) {
    throw new Error("No session ID");
  }

  return await resolve(
    axios.post(
      `${API_AUTH_URL}/users/change/language`,
      {
        lang: language,
      },
      {
        headers: {
          "session_id": sessionId,
          "Content-Type": "application/json",
        },
      }
    )
  );
}
